"use client";

import {
	Dialog,
	DialogBackdrop,
	DialogPanel,
	DialogTitle,
} from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { CheckIcon } from "@heroicons/react/24/solid";

export default function Modal({
	open,
	onClose,
	title = "Confirm Action",
	message = "Are you sure you want to proceed?",
	confirmText = "Confirm",
	cancelText = "",
	onConfirm,
	children,
	icono,
}) {
	return (
		<Dialog open={open} onClose={onClose} className="relative z-10">
			<DialogBackdrop className="fixed inset-0 bg-gray-500/75" />

			<div className="fixed inset-0 z-10 w-screen overflow-y-auto">
				<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
					<DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
						<div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
							<div className="sm:flex sm:items-start">
								{icono === "1" ? (
									<div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:size-10">
										<CheckIcon
											aria-hidden="true"
											className="size-6 text-green-600"
										/>
									</div>
								) : (
									<div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
										<ExclamationTriangleIcon
											aria-hidden="true"
											className="size-6 text-red-600"
										/>
									</div>
								)}

								<div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
									<DialogTitle
										as="h3"
										className="text-base font-semibold text-gray-900"
									>
										{title}
									</DialogTitle>
									<div className="mt-2">
										{children ? (
											children
										) : (
											<p className="text-sm text-gray-500">{message}</p>
										)}
									</div>
								</div>
							</div>
						</div>
						<div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              {/* boton vacio sigifica que no se va a mostrar el boton de cancelar */}
							{cancelText && cancelText.trim() !== "" ? (
								<button
									type="button"
									onClick={onConfirm}
									className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
								>
									{confirmText}
								</button>
							) : (
								<button
									type="button"
									onClick={onConfirm}
									className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto"
								>
									{confirmText}
								</button>
							)}
							{cancelText && cancelText.trim() !== "" && (
								<button
									type="button"
									onClick={onClose}
									className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
								>
									{cancelText}
								</button>
							)}
						</div>
					</DialogPanel>
				</div>
			</div>
		</Dialog>
	);
}
